<template>
	<!-- 监理周报 -->
	<div class="mod-config">
		<div ref="basic" style="height:20px;margin-top:-20px"></div>
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" label-width="auto" :inline="true"
			class="border-form">
			<el-card style="margin-top: 20px; height: 100%;">
				<el-row>
					<el-input class="monthly-input" style="width: 150px;" v-model="dataForm.monthlyName"
						placeholder="请输入" v-if="basicVisible">
					</el-input>
					<span v-if="!basicVisible" style="font-weight: bold;font-size:16px">
						{{ dataForm.monthlyName }}
					</span>
				</el-row>

				<el-row style="text-align:center;font-weight:bold;font-size: 17px;">
					<span>
						监理月报
					</span>
					<div style="margin:5px 0">第
						<el-input class="monthly-input" style="width: 40px;margin-right: 5px;"
							v-model="dataForm.monthlyTerm" v-if="basicVisible">
						</el-input>
						<span v-if="!basicVisible" style="font-weight: bold;font-size:16px">
							{{ dataForm.monthlyTerm }}
						</span>期
					</div>
					<div style="margin-bottom:5px">{{ dataForm.showMonthlyDate }}</div>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="项目名称" class="item">
							<span class="set_span">
								{{ dataForm.projectName }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="数量" class="item">
							<el-input class="sp-input" v-model="dataForm.projectNum" placeholder="请输入"
								v-if="basicVisible">
							</el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectNum }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="24">
						<el-form-item label-width="120px" label="委托方" class="item">
							<span class="set_span">
								{{ dataForm.projectEntrust }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="工程承包方" class="item">
							<span class="set_span">
								{{ dataForm.contractCompany }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="工程编号" class="item">
							<el-input class="sp-input" v-model="dataForm.projectSubjectNo" placeholder="请输入"
								v-if="basicVisible">
							</el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectSubjectNo }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="项目总监" class="item">
							<el-input class="sp-input" v-model="dataForm.projectDirector" placeholder="请输入"
								v-if="basicVisible">
							</el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectDirector }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12" style="text-align: right;padding: 4px 2px 0 0;">
						<el-button class="btn" type="primary" size="small" @click="updateBasicHandle()"
							v-if="!basicVisible">修改</el-button>
						<el-button class="btn" type="primary" size="small" @click="saveBasicHandle()"
							v-if="basicVisible">保存</el-button>
						<el-button class="rebtn" size="small" @click="cancelSaveBasicHandle()"
							v-if="basicVisible">取消</el-button>
					</el-col>
				</el-row>
				<div ref="overview"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">1. 本月概述</div>
				<el-row>
					<draggable v-model="dataForm.projectDesc" @start="onDragStart('010000', '', '')"
						@update="onDragEnd">
						<el-row v-for="(prodec, index) in dataForm.projectDesc" :key="'prodec' + index">
							<el-tooltip v-if="prodec.updUserName && prodec.updDate" placement="top" effect="light"
								:content="`${prodec.updUserName} ${prodec.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_non" :style="getFileItemBgStyle(prodec)">
										<el-col :span="22" class="desc_span">
											{{ prodec.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="prodec.showButton == 1"
												@click="addOrUpdateSituation(prodec.recNo, '010000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="prodec.showButton == 1"
												@click="deleteMonthlyReportFile(prodec.recNo, '010000')">
												×
											</el-button>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in prodec.photoRecords"
												:key="'prodecPhoto' + index1" style="margin-top: 20px;"
												v-if="prodec.photoRecords != undefined && prodec.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '010000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('010000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspanDetail">1.1 本月生产进度</span>
							<el-radio-group v-model="dataForm.productionSchedule" @change="saveBasicHandle()"
								:disabled="updateFlg || addFlg || basicVisible">
								<el-radio label="0">正常</el-radio>
								<el-radio label="1">缓慢</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="display:flex;justify-content: flex-start;">
						<el-form-item label-width="0">
							<span class="itemLabelspanDetail1">1.2 本月工程质量状况</span>
							<el-radio-group v-model="dataForm.qualitySituation" @change="saveBasicHandle()"
								:disabled="updateFlg || addFlg || basicVisible">
								<el-radio label="0">正常</el-radio>
								<el-radio label="1">不正常</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:119px"> 1.3 本月发出监理联系单 共 </span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.contactNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:119px"> 1.4 本月发出监理通知单 共 </span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.noticeNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:123px">1.5 本月发出不一致报告 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.disAccordNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:162px">1.6 本月文件审查 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.fileCheckNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan" style="margin-right:109px">1.7 除巡检外本月报验项目 共</span>
							<div class="summaryvalueSpan1">
								<span class="summaryvalue1"> {{ dataForm.itemCheckNum }} </span>
								<span>份</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<div ref="progress"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">2. 进度情况</div>
				<el-row>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.1 目前工程进度与节点计划比较</span>
						</el-form-item>
					</el-col>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabeltext"> 项目合同工期</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :data="dataForm.contractList" header-align="center" border
							style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="projectNo" label="船号" align="center" width="250">
							</el-table-column>
							<el-table-column label="交船期" align="center" prop="deliverDate">
								<!-- <template slot-scope="scope">
									<el-input class="selItemInput" v-model="scope.row.deliverDate" placeholder="请输入"
										style="width: 400px"></el-input>
								</template> -->
							</el-table-column>
							<el-table-column label="备  注" align="center" prop="remark" width="300">
								<!-- <template slot-scope="scope">
									<el-input class="selItemInput" v-model="scope.row.remark" placeholder="请输入"
										style="width: 280px"></el-input>
								</template> -->
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabeltext"> 各船具体节点计划及执行情况</span>
						</el-form-item>
					</el-col>
					<el-table max-height="600" :row-class-name="tableRowClassName" :span-method="objectNodeSpanMethod"
						ref="dataListTable" class="dataListTable" border :data="nodeList" header-align="center"
						header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }"
						:header-cell-style="headClass" style="margin-bottom: 20px;font-size: 12px">
						<el-table-column v-for="(v, idx) in headers" :key="idx"
							v-if="headers != undefined && headers.length > 0 && v.nodeId === '0'" :label="v.nodeName"
							:prop="v.nodeId" align="center" width="130px">
							<template slot-scope="scope">
								<span style="font-weight:bolder">
									{{ scope.row.subjectName }}
								</span>
							</template>
						</el-table-column>
						<el-table-column v-for="(v, idx) in headers" :key="idx"
							v-if="headers != undefined && headers.length > 0 && v.nodeId === '1'" :label="v.nodeName"
							:prop="v.nodeId" align="center" width="60px">
							<template slot-scope="scope">
								<span style="font-weight:bolder">
									{{ scope.row.title }}
								</span>
							</template>
						</el-table-column>
						<el-table-column v-for="(v, idx) in headers" :key="idx"
							v-if="headers != undefined && headers.length > 0 && idx > 1" :label="v.nodeName"
							:prop="v.nodeId" align="center">
							<template slot-scope="scope">
								<span>
									{{ scope.row.contentList[idx - 2].colValue }}
								</span>
							</template>
						</el-table-column>
					</el-table>
				</el-row>
				<el-row>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.2 目前工程进度与节点计划分析</span></el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-row v-for="(progressPlan, index) in dataForm.progressPlanDesc" :key="'progressPlan' + index">
						<el-row v-if="showSubjectName"" class=" set_sub">{{ progressPlan.projectNo }}</el-row>
						<draggable v-model="progressPlan.reportDescInfos" @start="onDragStart('020200', index, '')"
							@update="onDragEnd">
							<el-row v-for="(progressplan, index1) in progressPlan.reportDescInfos"
								:key="'progressplanDesc' + index1" class="subject_blank">
								<el-tooltip v-if="progressplan.updUserName && progressplan.updDate" placement="top"
									effect="light" :content="`${progressplan.updUserName} ${progressplan.updDate}`"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;">
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_non" :style="getFileItemBgStyle(progressplan)">
											<el-col :span="22" class="desc_span">
												{{ progressplan.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="progressplan.showButton == 1"
													@click="addOrUpdateSituation(progressplan.recNo, '020200', progressPlan.subjectNo)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="progressplan.showButton == 1"
													@click="deleteMonthlyReportFile(progressplan.recNo, '020200')">
													×
												</el-button>
											</el-col>
											<el-col :span="23" style="width:90%;margin-left:170px">
												<div v-for="(photo, index1) in progressplan.photoRecords"
													:key="'progressplanPhoto' + index1" style="margin-top: 20px;"
													v-if="progressplan.photoRecords != undefined && progressplan.photoRecords.length > 0">
													<el-col :span="9">
														<div style="margin:20px 20px 20px 20px ">
															<el-image style="height: 250px;"
																:src="photo.compressedPathUri" fit='contain'></el-image>
														</div>
													</el-col>
												</div>
											</el-col>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '020200', progressPlan.subjectNo)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('020200', progressPlan.subjectNo)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.3 详细进度情况</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.3.1 船体结构进度情况</span>
						</el-form-item>
					</el-col>
					<el-row>
						<el-col :span="24" style="padding-bottom: 10px">
							<el-table class="dataListTable" :data="dataForm.shipProgressList" header-align="center"
								:span-method="objectSpanMethod" style="width: 100%;font-size: 12px" border
								:header-cell-style="headClass" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }">
								<el-table-column prop="projectNo" label="工程编号" align="center">
								</el-table-column>
								<el-table-column label="" align="center">
									<template slot-scope="scope">
										<span v-if="scope.row.progressType === '0'">本 月</span>
										<span v-if="scope.row.progressType === '1'">累 计</span>
										<span v-if="scope.row.progressType === '2'">完工率%</span>
									</template>
								</el-table-column>
								<el-table-column label="上胎架数量" align="center" prop="upperMouldingNum">
								</el-table-column>
								<el-table-column label="验收完成数" align="center" prop="checkFinishNum">
								</el-table-column>
								<el-table-column label="涂装完工数" align="center" prop="paintingFinishNum">
								</el-table-column>
								<el-table-column label="总装分段数" align="center" prop="upShipPartNum">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
					<el-row v-for="(shipProgress, index) in dataForm.shipProgressDesc" :key="'shipProgress' + index">
						<el-row v-if="showSubjectName" class="set_sub">{{ shipProgress.projectNo }}</el-row>
						<draggable v-model="shipProgress.reportDescInfos" @start="onDragStart('020301', index, '')"
							@update="onDragEnd">
							<el-row v-for="(shipprogress, index1) in shipProgress.reportDescInfos"
								:key="'shipprogressDesc' + index1" class="subject_blank">
								<el-tooltip v-if="shipprogress.updUserName && shipprogress.updDate" placement="top"
									effect="light" :content="`${shipprogress.updUserName} ${shipprogress.updDate}`"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;">
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_non" :style="getFileItemBgStyle(shipprogress)">
											<el-col :span="22" class="desc_span">
												{{ shipprogress.descContent }}
											</el-col>
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="shipprogress.showButton == 1"
												@click="addOrUpdateSituation(shipprogress.recNo, '020301', shipProgress.subjectNo)">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="shipprogress.showButton == 1"
												@click="deleteMonthlyReportFile(shipprogress.recNo, '020301')">
												×
											</el-button>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in shipprogress.photoRecords"
												:key="'shipprogressPhoto' + index1" style="margin-top: 20px;"
												v-if="shipprogress.photoRecords != undefined && shipprogress.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '020301', shipProgress.subjectNo)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('020301', shipProgress.subjectNo)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label-width="0">
								<span class="itemLabelspan">2.3.2 涂装工程进度情况</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-row v-for="(paintingProgress, index) in dataForm.paintingProgressList"
							:key="'paintingProgress' + index">
							<el-row v-if="showSubjectName" class="set_sub">{{ paintingProgress.projectNo }}</el-row>
							<draggable v-model="paintingProgress.reportDescInfos"
								@start="onDragStart('020302', index, '')" @update="onDragEnd">
								<el-row v-for="(reportDesc, index1) in paintingProgress.reportDescInfos"
									:key="'paintingProgressDesc' + index1" class="subject_blank">
									<el-tooltip v-if="reportDesc.updUserName && reportDesc.updDate" placement="top"
										effect="light" :content="`${reportDesc.updUserName} ${reportDesc.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
											<el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col>
											<el-col :span="23" class="set_non" :style="getFileItemBgStyle(reportDesc)">
												<el-col :span="22" class="desc_span">
													{{ reportDesc.descContent }}
												</el-col>
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="addOrUpdateSituation(reportDesc.recNo, '020302', paintingProgress.subjectNo)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="deleteMonthlyReportFile(reportDesc.recNo, '020302')">
													×
												</el-button>
											</el-col>
											<el-col :span="23" style="width:90%;margin-left:170px">
												<div v-for="(photo, index1) in reportDesc.photoRecords"
													:key="'paintingProgressPhoto' + index1" style="margin-top: 20px;"
													v-if="reportDesc.photoRecords != undefined && reportDesc.photoRecords.length > 0">
													<el-col :span="9">
														<div style="margin:20px 20px 20px 20px ">
															<el-image style="height: 250px;"
																:src="photo.compressedPathUri" fit='contain'></el-image>
														</div>
													</el-col>
												</div>
											</el-col>
										</el-col>
									</el-tooltip>
								</el-row>
							</draggable>
							<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
								<el-tooltip content="添加描述" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="addOrUpdateSituation('', '020302', paintingProgress.subjectNo)">
										<i class="el-icon-plus btn-icon"></i>
									</el-button>
								</el-tooltip>
								<el-tooltip content="上期数据参考" placement="top" effect="light">
									<el-button class="week_btn" type="primary" size="small"
										@click="lastRecordRefHandle('020302', paintingProgress.subjectNo)">
										<i class="el-icon-document btn-icon"></i>
									</el-button>
								</el-tooltip>
							</el-col>
						</el-row>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label-width="0">
								<span class="itemLabelspan">2.3.3 轮机工程进度情况</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-for="(turbineProgress, index) in dataForm.turbineProgressDesc"
						:key="'turbineProgress' + index">
						<el-row class="set_sub" v-if="showSubjectName">{{ turbineProgress.projectNo }}</el-row>
						<draggable v-model="turbineProgress.reportDescInfos" @start="onDragStart('020303', index, '')"
							@update="onDragEnd">
							<el-row v-for="(reportDesc, index1) in turbineProgress.reportDescInfos"
								:key="'turbineProgressDesc' + index1" class="subject_blank">
								<el-tooltip v-if="reportDesc.updUserName && reportDesc.updDate" placement="top"
									effect="light" :content="`${reportDesc.updUserName} ${reportDesc.updDate}`"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;">
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_non" :style="getFileItemBgStyle(reportDesc)">
											<el-col :span="22" class="desc_span">
												{{ reportDesc.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="addOrUpdateSituation(reportDesc.recNo, '020303', turbineProgress.subjectNo)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="deleteMonthlyReportFile(reportDesc.recNo, '020303')">
													×
												</el-button>
											</el-col>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in reportDesc.photoRecords"
												:key="'turbineProgressPhoto' + index1" style="margin-top: 20px;"
												v-if="reportDesc.photoRecords != undefined && reportDesc.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '020303', turbineProgress.subjectNo)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('020303', turbineProgress.subjectNo)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<el-form-item label-width="0">
								<span class="itemLabelspan">2.3.4 电气工程进度情况</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-for="(electricalProgress, index) in dataForm.electricalProgressDesc"
						:key="'electricalProgress' + index">
						<el-row class="set_sub" v-if="showSubjectName">{{ electricalProgress.projectNo }}</el-row>
						<draggable v-model="electricalProgress.reportDescInfos"
							@start="onDragStart('020304', index, '')" @update="onDragEnd">
							<el-row v-for="(reportDesc, index1) in electricalProgress.reportDescInfos"
								:key="'electricalProgressDesc' + index1" class="subject_blank">
								<el-tooltip v-if="reportDesc.updUserName && reportDesc.updDate" placement="top"
									effect="light" :content="`${reportDesc.updUserName} ${reportDesc.updDate}`"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_non" :style="getFileItemBgStyle(reportDesc)">
											<el-col :span="22" class="desc_span">
												{{ reportDesc.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="addOrUpdateSituation(reportDesc.recNo, '020304', electricalProgress.subjectNo)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="deleteMonthlyReportFile(reportDesc.recNo, '020304')">
													×
												</el-button>
											</el-col>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in reportDesc.photoRecords"
												:key="'electricalProgressPhoto' + index1" style="margin-top: 20px;"
												v-if="reportDesc.photoRecords != undefined && reportDesc.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '020304', electricalProgress.subjectNo)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('020304', electricalProgress.subjectNo)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<el-row v-for="(customMajorProgress, index) in dataForm.customMajorProgressList"
					:key="'customMajorProgress' + index"
					v-if="dataForm.customMajorProgressList != null && dataForm.customMajorProgressList.length > 0">
					<el-row>
						<el-col :span="24">
							<el-form-item label-width="0">
								<span class="itemLabelspan">{{ customMajorProgress.title }}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row v-for="(customMajor, index3) in customMajorProgress.progressList"
						:key="'customMajor' + index3">
						<el-row class="set_sub" v-if="showSubjectName">{{ customMajor.projectNo }}</el-row>
						<draggable v-model="customMajor.reportDescInfos" @start="onDragStart('020300', index, index3)"
							@update="onDragEnd">
							<el-row v-for="(reportDesc, index1) in customMajor.reportDescInfos"
								:key="'customMajor' + index1" class="subject_blank">
								<el-tooltip v-if="reportDesc.updUserName && reportDesc.updDate" placement="top"
									effect="light" :content="`${reportDesc.updUserName} ${reportDesc.updDate}`"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;">
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_non" :style="getFileItemBgStyle(reportDesc)">
											<el-col :span="22" class="desc_span">
												{{ reportDesc.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="addOrUpdateSituation(reportDesc.recNo, '020300', customMajor.subjectNo, customMajorProgress.majorCode, customMajorProgress.majorName)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="reportDesc.showButton == 1"
													@click="deleteMonthlyReportFile(reportDesc.recNo, '020300')">
													×
												</el-button>
											</el-col>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in reportDesc.photoRecords"
												:key="'customMajorPhoto' + index1" style="margin-top: 20px;"
												v-if="reportDesc.photoRecords != undefined && reportDesc.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '020300', customMajor.subjectNo, customMajorProgress.majorCode, customMajorProgress.majorName)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('020300', customMajor.subjectNo, customMajorProgress.majorCode, customMajorProgress.majorName)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.4 月末进度照片</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(progressPhotoRecord, idxs) in dataForm.progressPhotoRecords"
					:key="'progressPhotoRecord' + idxs">
					<el-row v-if="showSubjectName" class="set_sub">{{ progressPhotoRecord.projectNo }}</el-row>
					<!-- <el-button v-preventReClick type="primary" size="small"
						:disabled="updateFlg || addFlg || basicVisible"
						style="margin-bottom: 10px; background-color: #00428e;"
						@click="handleProgressPhotoSelect(progressPhotoRecord, idxs)">选择照片</el-button> -->
					<el-col :span="24">
						<div class="card-container">
							<div class="card-row" v-for="(row, rowIndex) in cardRows(progressPhotoRecord.photoList)"
								:key="'progressRecord' + rowIndex">
								<el-row>
									<div class="card" v-for="(item, colIndex) in row" :key="item.recNo"
										@dragstart="dragStart('progress', idxs, rowIndex, colIndex)" @dragover.prevent
										@drop="drop('progress', idxs, rowIndex, colIndex)" @dragend="dragEnd()"
										draggable="true">
										<el-col :span="4">
											<el-card :body-style="{ padding: '0px' }"
												style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
												<el-image :src="item.photoPathUri" fit="scale-down"
													class="image"></el-image>
												<div style="padding: 2px 10px;">
													<div class="t-column-ellipsis">
														<span>{{ item.photoContent }}</span>
													</div>
													<div class="bottom clearfix">
														<el-button type="text" class="button"
															:disabled="updateFlg || addFlg || basicVisible"
															@click="delImg(item.recNo)">删除</el-button>
														<el-button type="text" class="button"
															:disabled="updateFlg || addFlg || basicVisible"
															style="margin-right: 10px;"
															@click="updateImgContent(item.recNo, item.photoContent)">修改</el-button>
													</div>
												</div>
											</el-card>
										</el-col>
									</div>
								</el-row>
							</div>
						</div>
					</el-col>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="选择照片" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="handleProgressPhotoSelect(progressPhotoRecord, idxs)">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row>
					<div v-if="!dataForm.progressPhotoRecords || dataForm.progressPhotoRecords.length === 0">
						<el-col :span="24">
							<span style="color: #e7b243;;font-size: 14px;">暂无进度照片</span>
						</el-col>
					</div>
				</el-row>
				<div ref="quality"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">3. 质量情况</div>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1 月度停止点检验汇总</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :data="dataForm.testRecordList" header-align="center" border
							style="width: 100%;font-size: 12px" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }"
							:span-method="objectTestRecordMethod">
							<el-table-column prop="projectNo" label="工程编号" align="center">
							</el-table-column>
							<el-table-column prop="majorName" label="专 业" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionCount" label="接受数" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionWhereCount" label="有条件接受" align="center">
							</el-table-column>
							<el-table-column prop="recheckAfterCorrectionCount" label="修正后复检" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionRefuseCount" label="不接受交验" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionRate" label="一次合格率" align="center">
								<template slot-scope="scope">
									{{ scope.row.testConclusionRate }}%
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2 巡检意见汇总</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :data="dataForm.patrolRectificationList" header-align="center"
							border style="width: 100%;font-size: 12px" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }"
							:span-method="objectInspectionMethod">
							<el-table-column label="工程编号" align="center">
								<template slot-scope="scope">
									{{ scope.row.projectNo }}
								</template>
							</el-table-column>
							<el-table-column label="专 业" align="center">
								<template slot-scope="scope">
									{{ scope.row.majorName }}
								</template>
							</el-table-column>
							<el-table-column prop="applyNum" label="本月提出整改数" align="center">
							</el-table-column>
							<el-table-column prop="withinFinishNum" label="本月已整改数" align="center">
							</el-table-column>
							<el-table-column prop="alreadyModifyNum" label="截止本月末整改数" align="center">
							</el-table-column>
							<!-- <el-table-column prop="notFinishNum" label="截止本月未整改数" align="center">
							</el-table-column> -->
							<el-table-column prop="finishRate" label="整改完成率" align="center">
								<template slot-scope="scope">
									{{ scope.row.finishRate }}%
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3 监理联系单汇总</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabeltext">截止本月末共下发</span>
							<span class="summaryvalue2"> {{ dataForm.contactTotalNum }} </span>
							<span class="itemLabeltext"> 份监理联系单，已整改完成</span>
							<span class="summaryvalue2"> {{ dataForm.contactFinishNum }} </span>
							<span class="itemLabeltext"> 份。</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(contactItemRecord, index) in dataForm.contactItemRecordList"
					:key="'contactItemRecord' + index">
					<el-row v-if="showSubjectName" class="set_sub">{{ contactItemRecord.projectNo }}</el-row>
					<el-col :span="24" style="margin-bottom: 10px;margin-top:10px">
						<el-table class="dataListTable" :data="contactItemRecord.itemRecordList" header-align="center"
							border style="width: 100%;font-size: 12px" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="noticeNo" label="监理联系单编号" min-width="200" align="left">
							</el-table-column>
							<el-table-column prop="primaryContent" label="主要内容" min-width="350" align="left">
							</el-table-column>
							<el-table-column prop="sendTime" label="下发日期" width="120" align="center">
							</el-table-column>
							<el-table-column prop="closeTime" label="封闭日期" width="120" align="center">
							</el-table-column>
							<el-table-column label="备 注" prop="remark" width="200" align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.4 监理通知单汇总</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabeltext">截止本月末共下发</span>
							<span class="summaryvalue2"> {{ dataForm.noticeTotalNum }} </span>
							<span class="itemLabeltext"> 份监理通知单，已整改完成</span>
							<span class="summaryvalue2"> {{ dataForm.noticeFinishNum }} </span>
							<span class="itemLabeltext"> 份。</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(noticeItemRecord, index) in dataForm.noticeItemRecordList"
					:key="'noticeItemRecord' + index">
					<el-col class="set_sub">{{ noticeItemRecord.projectNo }}</el-col>
					<el-col :span="24" style="margin-bottom: 10px;margin-top:10px">
						<el-table class="dataListTable" :data="noticeItemRecord.itemRecordList" header-align="center"
							border style="width: 100%;font-size: 12px" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column prop="noticeNo" label="监理通知单编号" min-width="200" align="left">
							</el-table-column>
							<el-table-column prop="primaryContent" label="主要内容" min-width="350" align="left">
							</el-table-column>
							<el-table-column prop="sendTime" label="下发日期" width="120" align="center">
							</el-table-column>
							<el-table-column prop="closeTime" label="封闭日期" width="120" align="center">
							</el-table-column>
							<el-table-column label="备 注" prop="remark" width="200" align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.5 不一致报告汇总</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<draggable v-model="dataForm.disAccordDesc" @start="onDragStart('030400', '', '')"
						@update="onDragEnd">
						<el-row v-for="(disAccord, index) in dataForm.disAccordDesc" :key="'disAccord' + index">
							<el-tooltip v-if="disAccord.updUserName && disAccord.updDate" placement="top" effect="light"
								:content="`${disAccord.updUserName} ${disAccord.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_non" :style="getFileItemBgStyle(disAccord)">
										<el-col :span="22" class="desc_span">
											{{ disAccord.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="disAccord.showButton == 1"
												@click="addOrUpdateSituation(disAccord.recNo, '030400')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="disAccord.showButton == 1"
												@click="deleteMonthlyReportFile(disAccord.recNo, '030400')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in disAccord.photoRecords"
											:key="'disAccordPhoto' + index1" style="margin-top: 20px;"
											v-if="disAccord.photoRecords != undefined && disAccord.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030400')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030400')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.6 本月施工质量分析</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(constructionQuality, index) in dataForm.constructionQualityDesc"
					:key="'constructionQuality' + index">
					<el-row class="set_sub" v-if="showSubjectName">{{ constructionQuality.projectNo }}</el-row>
					<el-row v-for="(conProgress, index1) in constructionQuality.conProgressList"
						:key="'conProgress' + index1">
						<el-row class="set_major">
							<el-col :span="24" class="conp">{{ conProgress.majorName }}</el-col>
						</el-row>
						<draggable v-model="conProgress.descProgressList" @start="onDragStart('030500', index, index1)"
							@update="onDragEnd">
							<el-row v-for="(qualityDesc, index2) in conProgress.descProgressList"
								:key="'qualityDesc' + index2" style="margin-left: 90px;">
								<el-tooltip v-if="qualityDesc.updUserName && qualityDesc.updDate" placement="top"
									effect="light" :content="`${qualityDesc.updUserName} ${qualityDesc.updDate}`"
									:enterable="false">
									<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(qualityDesc)">
											<el-col :span="22" class="desc_span">
												{{ qualityDesc.descContent }}
											</el-col>
											<!-- 占位 -->
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="qualityDesc.showButton == 1"
												@click="addOrUpdateSituation(qualityDesc.recNo, '030500', constructionQuality.subjectNo, conProgress.major)">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="qualityDesc.showButton == 1"
												@click="deleteMonthlyReportFile(qualityDesc.recNo, '030500')">
												×
											</el-button>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in qualityDesc.photoRecords"
												:key="'conQualityPhoto' + index1" style="margin-top: 20px;"
												v-if="qualityDesc.photoRecords != undefined && qualityDesc.photoRecords.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
							</el-row>
						</draggable>
						<!-- <el-col :span="24" style="margin-top:10px">
								<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
									:disabled="updateFlg || addFlg || basicVisible" style="background-color: #00428e;"
									@click="addConstructionQualityDescItem(constructionQuality.subjectNo, conQuality.major, index, index1)">追加</el-button>
							</el-col> -->
						<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
							<el-tooltip content="添加描述" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '030500', constructionQuality.subjectNo, conProgress.major)">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('030500', constructionQuality.subjectNo, conProgress.major)">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.7 报告文件审查情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.fileCheckRecords" header-align="center" border
							style="width: 100%;font-size: 12px;" header-cell-class-name="dataListTHeader"
							:header-cell-style="headClass" :cell-style="{ padding: '0px' }">
							<el-table-column type="index" label="序号" align="center" width="150">
							</el-table-column>
							<el-table-column prop="fileName" label="文件名称" align="center" min-width="250">
							</el-table-column>
							<el-table-column prop="examineStatusName" label="审查状态" align="center" min-width="150">
							</el-table-column>
							<el-table-column prop="examineSuggestion" label="审查意见" align="center" min-width="150">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.8 设计修改、图纸审查（终审）落实情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<draggable v-model="dataForm.designEditDesc" @start="onDragStart('030700', '', '')"
						@update="onDragEnd">
						<el-row v-for="(designedit, index) in dataForm.designEditDesc" :key="'designedit' + index">
							<el-tooltip v-if="designedit.updUserName && designedit.updDate" placement="top"
								effect="light" :content="`${designedit.updUserName} ${designedit.updDate}`"
								:enterable="false">
								<el-col :span="24" style="cursor: pointer;"> <!-- 整行触发 -->
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_non" :style="getFileItemBgStyle(designedit)">
										<el-col :span="22" class="desc_span">
											{{ designedit.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="designedit.showButton == 1"
												@click="addOrUpdateSituation(designedit.recNo, '030700')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="designedit.showButton == 1"
												@click="deleteMonthlyReportFile(designedit.recNo, '030700')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in designedit.photoRecords"
											:key="'designeditPhoto' + index1" style="margin-top: 20px;"
											v-if="designedit.photoRecords != undefined && designedit.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<!-- <el-col :span="24" style="margin-bottom: 20px;margin-top: 10px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							:disabled="updateFlg || addFlg || basicVisible" style="background-color: #00428e;"
							@click="addDesignEditDescItem()">追加设计修改、图纸审查（终审）落实情况</el-button>
					</el-col> -->
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '030700')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('030700')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.9 质量照片</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(qualityPhotoRecord, idxs) in dataForm.qualityPhotoRecords"
					:key="'qualityPhotoRecord' + idxs">
					<el-row v-if="showSubjectName" class="set_sub">{{ qualityPhotoRecord.projectNo }}</el-row>
					<!-- <el-button v-preventReClick type="primary" size="small"
						:disabled="updateFlg || addFlg || basicVisible"
						style="margin-bottom: 10px;background-color: #00428e;"
						@click="handleQualityPhotoSelect(qualityPhotoRecord, idxs)">选择照片</el-button> -->
					<el-col :span="24">
						<div class="card-container">
							<div class="card-row" v-for="(row, rowIndex) in cardRows(qualityPhotoRecord.photoList)"
								:key="'qualityRecord' + rowIndex">
								<el-row>
									<div class="card" v-for="(item, colIndex) in row" :key="item.recNo"
										@dragstart="dragStart('quality', idxs, rowIndex, colIndex)" @dragover.prevent
										@drop="drop('quality', idxs, rowIndex, colIndex)" @dragend="dragEnd()"
										draggable="true">
										<el-col :span="4">
											<el-card :body-style="{ padding: '0px' }"
												style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
												<el-image :src="item.photoPathUri" fit="scale-down"
													class="image"></el-image>
												<div style="padding: 2px 10px;">
													<div class="t-column-ellipsis">
														<span class="report_font">{{ item.photoContent }}</span>
													</div>
													<div class="bottom clearfix">
														<el-button type="text" class="button"
															:disabled="updateFlg || addFlg || basicVisible"
															@click="delImg(item.recNo)">删除</el-button>
														<el-button type="text" class="button"
															:disabled="updateFlg || addFlg || basicVisible"
															style="margin-right: 10px;"
															@click="updateImgContent(item.recNo, item.photoContent)">修改</el-button>
													</div>
												</div>
											</el-card>
										</el-col>
									</div>
								</el-row>
							</div>
						</div>
					</el-col>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="选择照片" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="handleQualityPhotoSelect(qualityPhotoRecord, idxs)">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div v-if="!dataForm.qualityPhotoRecords || dataForm.qualityPhotoRecords.length === 0">
					<span style="color: #e7b243;font-size: 14px;">暂无质量照片</span>
				</div>
				<div ref="meet"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">4. 会议情况</div>
				<draggable v-model="dataForm.meetingDesc" @start="onDragStart('040000')" @update="onDragEnd">
					<el-row :span="24" v-for="(meeting, index) in dataForm.meetingDesc" :key="'meet' + index">
						<el-tooltip v-if="meeting.updUserName && meeting.updDate" placement="top" effect="light"
							:content="`${meeting.updUserName} ${meeting.updDate}`" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(meeting)">
									<el-col :span="22" class="desc_span">
										{{ meeting.descContent }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="meeting.showButton == 1"
											@click="addOrUpdateSituation(meeting.recNo, '040000')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="meeting.showButton == 1"
											@click="deleteMonthlyReportFile(meeting.recNo, '040000')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in meeting.photoRecords" :key="'meetingPhoto' + index1"
										style="margin-top: 20px;"
										v-if="meeting.photoRecords != undefined && meeting.photoRecords.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加会议情况 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '040000')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="从监理会议模块提取 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="selectMeetingHandle('040000')">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="从协调记录模块提取 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="selectCoordinateHandle('040000')">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('040000')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div ref="hse"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">5. HSE情况</div>
				<el-row>
					<draggable v-model="dataForm.hseInfoDesc" @start="onDragStart('050000', '', '')"
						@update="onDragEnd">
						<el-row v-for="(hseinfo, index) in dataForm.hseInfoDesc" :key="'hseinfo' + index">
							<el-tooltip v-if="hseinfo.updUserName && hseinfo.updDate" placement="top" effect="light"
								:content="`${hseinfo.updUserName} ${hseinfo.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(hseinfo)">
										<el-col :span="22" class="desc_span">
											{{ hseinfo.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="hseinfo.showButton == 1"
												@click="addOrUpdateSituation(hseinfo.recNo, '050000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="hseinfo.showButton == 1"
												@click="deleteMonthlyReportFile(hseinfo.recNo, '050000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in hseinfo.photoRecords" :key="'hsePhoto' + index1"
											style="margin-top: 20px;"
											v-if="hseinfo.photoRecords != undefined && hseinfo.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-row>
						<el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
							<el-tooltip content="添加描述 " placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '050000')">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('050000')">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
					<!-- <el-col :span="24" style="margin-bottom: 20px;margin-top: 10px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							:disabled="updateFlg || addFlg || basicVisible" style="background-color: #00428e;"
							@click="addHseInfoDescItem()">追加HSE情况</el-button>
					</el-col> -->
				</el-row>
				<div ref="other"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">6. 其他需要说明的问题</div>
				<el-row>
					<draggable v-model="dataForm.otherDesc" @start="onDragStart('060000', '', '')" @update="onDragEnd">
						<el-row v-for="(other, index) in dataForm.otherDesc" :key="'other' + index">
							<el-tooltip v-if="other.updUserName && other.updDate" placement="top" effect="light"
								:content="`${other.updUserName} ${other.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(other)">
										<el-col :span="22" class="desc_span">
											{{ other.descContent }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="other.showButton == 1"
												@click="addOrUpdateSituation(other.recNo, '060000')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="other.showButton == 1"
												@click="deleteMonthlyReportFile(other.recNo, '060000')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in other.photoRecords" :key="'otherPhoto' + index1"
											style="margin-top: 20px;"
											v-if="other.photoRecords != undefined && other.photoRecords.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<!-- <el-col :span="24" style="margin-bottom: 20px;margin-top: 10px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							:disabled="updateFlg || addFlg || basicVisible" style="background-color: #00428e;"
							@click="addOtherDescItem()">追加其他需要说明的问题</el-button>
					</el-col> -->
					<el-row>
						<el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
							<el-tooltip content="添加描述 " placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="addOrUpdateSituation('', '060000')">
									<i class="el-icon-plus btn-icon"></i>
								</el-button>
							</el-tooltip>
							<el-tooltip content="上期数据参考" placement="top" effect="light">
								<el-button class="week_btn" type="primary" size="small"
									@click="lastRecordRefHandle('060000')">
									<i class="el-icon-document btn-icon"></i>
								</el-button>
							</el-tooltip>
						</el-col>
					</el-row>
				</el-row>
				<div ref="enclosure"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;margin-bottom:50px">
				<div class="elCardTitle">7. 随月报发送的附件</div>
				<el-row>
					<el-col :span="2"><el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-upload"
							@click="editHandle()">添加附件</el-button></el-col>
					<el-col :span="4">
						<el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-refresh"
							@click="refreshEnclosureFiles()">生成/刷新附件</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table ref="singleTable" class="dataListTable" :data="enclosureList" header-align="center"
							border style="width: 100%;font-size: 12px;" empty-text="保存后请通过附件上传功能上传附件"
							:header-cell-style="headClass" header-cell-class-name="dataListTHeader" row-key="recNo"
							:cell-style="{ padding: '0px' }">
							<el-table-column type="index" label="序号" align="center" width="60">
							</el-table-column>
							<el-table-column prop="fileName" label="文件名称" align="left" min-width="250">
							</el-table-column>
							<el-table-column prop="remark" label="备注" align="center" min-width="150">
							</el-table-column>
							<el-table-column label="操作" prop="remark" align="center" width="300">
								<template slot-scope="scope">
									<el-button v-preventReClick type="danger" size="small"
										@click="downloadHandle(scope.row.filePathUri, scope.row.fileName)"
										v-if="scope.row.filePathUri">下载</el-button>
									<el-button v-preventReClick type="warning" size="small"
										@click="editHandle(scope.row.recNo)">修改</el-button>
									<el-button v-preventReClick type="danger" size="small"
										@click="deleteHandle(scope.row.recNo)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
		<el-row style="height:68px">
		</el-row>
		<!-- <el-row class="formBtnGroup" style="margin-top: 40px;">
			<div class="set_bg">
				<el-button v-preventReClick class="btn1" type="primary" size="small"
					@click="dataFormSubmit()">保存</el-button>
				<el-button v-preventReClick class="rebtn1" size="small" plain @click="goBack()">取消</el-button>
			</div>
		</el-row> -->
		<el-row>
			<div class="set_btn" v-if="menuId !== 'basic'" @click="jump_to_basic" style="bottom: 147px;"></div>
			<div class="set_btn_border" v-if="menuId === 'basic'" @click="jump_to_basic" style="bottom: 147px;"></div>
			<div class="set_menu" style="bottom: 145px;" @click="jump_to_basic">基本信息</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'overview'" @click="jump_to_overview" style="bottom: 127px;"></div>
			<div class="set_btn_border" v-if="menuId === 'overview'" @click="jump_to_overview" style="bottom: 127px;">
			</div>
			<div class="set_menu" style="bottom: 125px;" @click="jump_to_overview">1.本月概述</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'progress'" @click="jump_to_progress" style="bottom: 107px;"></div>
			<div class="set_btn_border" v-if="menuId === 'progress'" @click="jump_to_progress" style="bottom: 107px;">
			</div>
			<div class="set_menu" style="bottom: 105px;" @click="jump_to_progress">2.进度情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'quality'" @click="jump_to_quality" style="bottom: 87px;"></div>
			<div class="set_btn_border" v-if="menuId === 'quality'" @click="jump_to_quality" style="bottom: 87px;">
			</div>
			<div class="set_menu" style="bottom: 85px;" @click="jump_to_quality">3.质量情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'meet'" @click="jump_to_meet" style="bottom: 67px;"></div>
			<div class="set_btn_border" v-if="menuId === 'meet'" @click="jump_to_meet" style="bottom: 67px;"></div>
			<div class="set_menu" style="bottom: 65px;" @click="jump_to_meet">4.会议情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'hse'" @click="jump_to_hse" style="bottom: 45px;"></div>
			<div class="set_btn_border" v-if="menuId === 'hse'" @click="jump_to_hse" style="bottom: 45px;"></div>
			<div class="set_menu" style="bottom: 45px;" @click="jump_to_hse">5.HSE情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'other'" @click="jump_to_other" style="bottom: 27px;"></div>
			<div class="set_btn_border" v-if="menuId === 'other'" @click="jump_to_other" style="bottom: 27px;"></div>
			<div class="set_menu" style="bottom: 25px;" @click="jump_to_other">6.其他需要说明的问题</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'enclosure'" @click="jump_to_enclosure" style="bottom: 7px;"></div>
			<div class="set_btn_border" v-if="menuId === 'enclosure'" @click="jump_to_enclosure" style="bottom: 7px;">
			</div>
			<div class="set_menu" style="bottom: 5px;" @click="jump_to_enclosure">7.随月报发送的附件</div>
		</el-row>

		<el-dialog title="添加照片" :visible.sync="dialogVisible" width="30%">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="工程编号">
							<el-select id="photoPojectNo" v-model="photoPojectNo" placeholder="请选择">
								<el-option v-for="item in subjectList" :key="item.displayValue" :label="item.projectNo"
									:value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="photoContent"
								placeholder="请填写"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="照片">
							<div class="addImgBox" v-for="(item, index) in photoList" :key="'psu' + index">
								<el-image style="width: 100%; height: 100%" :src="item.photoPathUri"
									fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delPhotoImg(index)"></i>
								</div>
							</div>
							<el-upload class="addImgBox" ref="uploadTempImg" :action="action"
								:http-request="uploadTempImg" accept="image/jpeg,image/png,image/jpg"
								v-if="!photoList || photoList.length === 0">
								<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
								</el-image>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick @click="dialogVisible = false">取 消</el-button>
				<el-button v-preventReClick type="primary" @click="savePhotoList">确 定</el-button>
			</span>

		</el-dialog>

		<el-dialog title="添加照片" :visible.sync="meetPhotoDialogVisible" width="30%">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="meetPhotoContent"
								placeholder="请填写"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="照片">
							<div class="addImgBox" v-for="(item, index) in meetPhotoList" :key="'sfg' + index">
								<el-image style="width: 100%; height: 100%" :src="item.photoFilePathUrl"
									fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delMeetDialogPhoto(index)"></i>
								</div>
							</div>
							<el-upload class="addImgBox" ref="uploadMeetImg" :action="action"
								:http-request="uploadMeetImg" accept="image/jpeg,image/png,image/jpg"
								v-if="!meetPhotoList || meetPhotoList.length === 0">
								<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
								</el-image>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick @click="meetPhotoDialogVisible = false">取 消</el-button>
				<el-button v-preventReClick type="primary" @click="saveMeetPhotoList">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 质量进度照片内容修改 -->
		<el-dialog title="修改描述" :visible.sync="updateImgContentVisable" width="30%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="">
							<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }"
								v-model="updatePhotoContent" placeholder="请填写" style="width:420px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick class="btn" type="primary" size="small" @click="saveImgContent">确
					定</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="updateImgContentVisable = false">取
					消</el-button>

			</span>
		</el-dialog>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getEnclosureList"></add-or-update>
		<quality-progress-photo-select v-if="qpPhotoSelectVisible" ref="qpPhotoSelect"
			@selectItems="margeSelectItems"></quality-progress-photo-select>
		<add-or-update-situation v-if="addOrUpdateSituationVisible" ref="addOrUpdateSituation"
			@refreshDataList="getMonthlySituationList"></add-or-update-situation>
		<choose-progress-record v-if="chooseProgressKindVisible" ref="chooseProgressRecord"
			@refreshDataList="getMonthlySituationList"></choose-progress-record>
		<last-record-ref v-if="lastRecordRefVisible" ref="lastRecordRef"
			@refreshDataList="getMonthlySituationList"></last-record-ref>
		<meeting-select v-if="meetingSelectVisible" ref="meetingSelect"
			@selectMeetingItems="margeSelectMeetingItems"></meeting-select>
		<select-coordinate v-if="selectCoordinateVisible" ref="selectCoordinate"
			@refreshDataList="getMonthlySituationList"></select-coordinate>
	</div>
</template>
<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js";
import AddOrUpdate from './monthly-enclosure-add-or-update'
import QualityProgressPhotoSelect from './quality-progress-photo-select'
import Sortable from "sortablejs";
import draggable from 'vuedraggable';
import AddOrUpdateSituation from './add-or-update-situation.vue'
import ChooseProgressRecord from './choose-progress-record.vue'
import LastRecordRef from './last-record-ref.vue'
import SelectCoordinate from './select-coordinate.vue'
import MeetingSelect from './meeting-select.vue'
export default {
	data() {
		return {
			basicVisible: false,
			addOrUpdateVisible: false,
			qpPhotoSelectVisible: false,
			enclosureList: [],
			photoFlag: 0,
			dialogVisible: false,
			meetPhotoDialogVisible: false,
			addOrUpdateSituationVisible: false,
			selectCoordinateVisible: false,
			chooseProgressKindVisible: false,
			meetingSelectVisible: false,
			lastRecordRefVisible: false,
			showSubjectName: false,
			meetPhotoListIndex: 0,
			addImg: addImg,
			recNo: '',
			beginTime: '',
			action: '',
			endTime: '',
			photoList: [],
			subjectList: [],
			majorList: [],
			meetPhotoList: [],
			photoPojectNo: '',
			subjectNo: '',
			photoContent: '',
			meetPhotoContent: '',
			workNo: $common.getItem("workNo"),
			dataRule: {},
			dataForm: {
			},
			photoViewCol: 6,
			draggedItem: {},
			selectPhotoType: '',
			recNos: [],
			updateImgContentVisable: false,
			photoType: '',
			photoRecNo: '',
			updatePhotoContent: '',
			contentIdx: '',
			menuId: 'basic',
			nodeList: [],
			headers: [],
			addFlg: false,
			updateFlg: false,
			updateDescRecNo: '',
			qpPhotoIndex: 0,
			updateDataType: '',
			updateIndex: '',
			updateIndex1: ''
		};
	},
	components: {
		AddOrUpdate,
		QualityProgressPhotoSelect,
		draggable,
		AddOrUpdateSituation,
		ChooseProgressRecord,
		LastRecordRef,
		MeetingSelect,
		SelectCoordinate
	},
	mounted() {
		this.recNo = this.$route.query.recNo;
		this.getNodeInfoList();
		this.getSubjectDropDown();
		this.getEnclosureList();
		this.getMajorList();
		this.dragSort();
		this.getMonthlyInfo();
	},
	methods: {
		getFileItemBgStyle(item) {
			if (item && item.oriRecNo) {
				return { backgroundColor: 'rgb(249 248 209 / 69%)' };
			}
			return {};
		},
		getCurrentDate() {
			//获取当前时间并打印
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			if (mm < 10) {
				mm = '0' + mm;
			}
			return yy + '.' + mm + '.' + dd;
		},
		objectTestRecordMethod({ row, column, rowIndex, columnIndex }) {
			// if (columnIndex === 0) {
			// 	// this.tableData  修改
			// 	const _row = (this.flitterSubjectNo(this.dataForm.testRecordList).one)[rowIndex];
			// 	const _col = _row > 0 ? 1 : 0;
			// 	return {
			// 		rowspan: _row,
			// 		colspan: _col
			// 	};
			// }
		},
		objectInspectionMethod({ row, column, rowIndex, columnIndex }) {
			// if (columnIndex === 0) {
			// 	// this.tableData  修改
			// 	const _row = (this.flitterSubjectNo(this.dataForm.patrolRectificationList).one)[rowIndex];
			// 	const _col = _row > 0 ? 1 : 0;
			// 	return {
			// 		rowspan: _row,
			// 		colspan: _col
			// 	};
			// }
		},
		flitterSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.projectNo === arr[index - 1].projectNo) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		onDragStart(dataType, index, index1) {
			this.updateDataType = dataType;
			this.updateIndex = index;
			this.updateIndex1 = index1;
		},
		onDragEnd(event) {
			event.preventDefault();
			// 拖拽结束后的处理逻辑
			let records = [];
			if (this.updateDataType == '010000') {
				// 1 本月概述
				records = this.dataForm.projectDesc
			} else if (this.updateDataType == '020200') {
				// 2.2 目前工程进度与节点计划分析
				records = this.dataForm.progressPlanDesc[this.updateIndex].reportDescInfos
			} else if (this.updateDataType == '020301') {
				// 2.3.1 船体结构进度情况
				records = this.dataForm.shipProgressDesc[this.updateIndex].reportDescInfos
			} else if (this.updateDataType == '020302') {
				// 2.3.2 涂装结构进度情况
				records = this.dataForm.paintingProgressList[this.updateIndex].reportDescInfos
			} else if (this.updateDataType == '020303') {
				// 2.3.3 轮机结构进度情况
				records = this.dataForm.turbineProgressDesc[this.updateIndex].reportDescInfos
			} else if (this.updateDataType == '020304') {
				// 2.3.4 电气结构进度情况
				records = this.dataForm.electricalProgressDesc[this.updateIndex].reportDescInfos
			} else if (this.updateDataType == '020300') {
				// 2.3.x 其他自定义的专业详细进度情况
				records = this.dataForm.customMajorProgressList[this.updateIndex].progressList[this.updateIndex1].reportDescInfos
			} else if (this.updateDataType == '030400') {
				// 3.4 不一致情况
				records = this.dataForm.disAccordDesc
			} else if (this.updateDataType == '030500') {
				// 3.5 本月施工质量分析
				records = this.dataForm.constructionQualityDesc[this.updateIndex].conProgressList[this.updateIndex1].descProgressList
			} else if (this.updateDataType == '030700') {
				// 3.7 设计修改、图纸审查（终审）落实情况
				records = this.dataForm.designEditDesc
			} else if (this.updateDataType == '050000') {
				// 5. HSE情况
				records = this.dataForm.hseInfoDesc
			} else if (this.updateDataType == '060000') {
				// 5. 其他需要说明的问题
				records = this.dataForm.otherDesc
			}
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportdescinfo/sort",
				method: "post",
				data: this.$http.adornData({
					dataType: this.updateDataType,
					monthlyRecNo: this.recNo,
					records: records
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.updateDataType = ''
							this.getMonthlySituationList();
						}
					});
				}
			});
		},
		getDescList(descList, subjectNo) {
			let list = [];
			if (descList) {
				for (let i = 0; i < descList.length; i++) {
					if (descList[i].subjectNo == subjectNo) {
						list.push(descList[i])
					}
				}
			}
			return list;
		},
		dragSort() {
			const el = this.$refs.singleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
			this.sortable = Sortable.create(el, {
				onEnd: e => {	//onEnd是结束拖拽时触发，onUpdate是列表内元素顺序更新的时候触发，更多请看文末配置项
					//e.oldIndex为拖动一行原来的位置，e.newIndex为拖动后新的位置
					const targetRow = this.enclosureList.splice(e.oldIndex, 1)[0];
					this.enclosureList.splice(e.newIndex, 0, targetRow);
					let recNo = this.enclosureList[e.newIndex].recNo;//拖动行的id
					// 后端发送请求排序
					this.$http({
						url: this.$store.state.httpUrl + "/business/monthreportenclosure/sort",
						method: "POST",
						data: this.$http.adornData({
							enclosureList: this.enclosureList,
							workNo: $common.getItem("workNo"),
							detailRecNo: this.recNo
						}),
					}).then(({ data }) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getEnclosureList()
								}
							})
						}
					});
				}
			})
		},
		/* 照片拖拽 begin */
		cardRows(photoList) {
			const rows = [];
			for (let i = 0; i < photoList.length; i += this.photoViewCol) {
				rows.push(photoList.slice(i, i + this.photoViewCol));
			}
			return rows;
		},
		dragStart(type, idxs, rowIndex, colIndex) {
			this.draggedItem = { type: type, idxs: idxs, row: rowIndex, col: colIndex };
		},
		drop(type, idxs, rowIndex, colIndex) {
			if (type !== this.draggedItem.type || idxs !== this.draggedItem.idxs) {
				return
			}
			const x = this.draggedItem.row * this.photoViewCol + this.draggedItem.col
			const y = rowIndex * this.photoViewCol + colIndex
			let photoList = []
			if (type === 'progress') {
				photoList = this.dataForm.progressPhotoRecords[idxs].photoList
			} else if (type === 'quality') {
				photoList = this.dataForm.qualityPhotoRecords[idxs].photoList
			} else if (type === 'meeting') {
				photoList = this.dataForm.meetingDesc[idxs].photoRecords
			}
			if (x == y) {
				return
			} else if (x < y) {
				const item = photoList.splice(x, 1)[0];
				photoList.splice(y, 0, item);
			} else {
				const item = photoList.splice(x, 1)[0];
				photoList.splice(y, 0, item);
			}

			if (photoList != undefined && photoList.length > 1) {
				// 直接保存至db
				let url = "";
				if (type === 'progress' || type === 'quality') {
					url = "/business/monthlyreportphoto/sort"
					// 质量照片和进度照片	
				} else if (type === 'meeting') {
					// 会议照片
					url = "/business/monthlyreportdescphoto/sort"
				}
				this.$http({
					url: this.$store.state.httpUrl + url,
					method: "POST",
					data: this.$http.adornData({
						records: photoList,
						monthlyRecNo: this.recNo
					}),
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getMonthlyPhotoList();
							}
						})
					}
				});
			}


		},
		dragEnd() {
			this.draggedItem = {};
		},
		updateBasicHandle() {
			this.basicVisible = true;
		},
		cancelSaveBasicHandle() {
			this.getMonthlyInfo()
		},
		saveBasicHandle() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/updateMonthlyBasic",
				method: 'post',
				data: this.$http.adornData({
					recNo: this.recNo,
					monthlyName: this.dataForm.monthlyName,
					projectNum: this.dataForm.projectNum,
					monthlyTerm: this.dataForm.monthlyTerm,
					projectSubjectNo: this.dataForm.projectSubjectNo,
					projectDirector: this.dataForm.projectDirector,
					qualitySituation: this.dataForm.qualitySituation,
					productionSchedule: this.dataForm.productionSchedule,
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.basicVisible = false;
							this.getMonthlyInfo()
						}
					})
				}
			})
		},
		delImg(recNo) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportphoto/delete/" + recNo,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getMonthlyPhotoList();
							}
						})
					}
				});
			})
		},
		updateImg(val) {
			this.recNos.push(val)
		},
		canelUpdateImg(val) {
			let colnum = this.recNos.length
			for (let i = 0; i < colnum; i++) {
				if (this.recNos[i] == val) {
					this.recNos.splice(i, 1)
				}
			}
		},
		addOrUpdateSituation(recNo, dataType, subjectNo, major, majorName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo, major);
			this.addOrUpdateSituationVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdateSituation.init(this.recNo, recNo, sort + 1, dataType, subjectNo, major, majorName)
			})
		},
		getMaxSort(dataType, subjectNo, major) {
			// 计算最大排序值
			let sort = 0;
			if (dataType === '010000' && this.dataForm.projectDesc != undefined && this.dataForm.projectDesc.length > 0) {
				for (var i = 0; i < this.dataForm.projectDesc.length; i++) {
					if (this.dataForm.projectDesc[i].sort > sort) {
						sort = this.dataForm.projectDesc[i].sort
					}
				}
			} else if (dataType === '020200' && this.dataForm.progressPlanDesc != undefined && this.dataForm.progressPlanDesc.length > 0) {
				for (var i = 0; i < this.dataForm.progressPlanDesc.length; i++) {
					let progressPlanDesc = this.dataForm.progressPlanDesc[i];
					if (progressPlanDesc.subjectNo === subjectNo) {
						let reportDescInfos = progressPlanDesc.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '020301' && this.dataForm.shipProgressDesc != undefined && this.dataForm.shipProgressDesc.length > 0) {
				for (var i = 0; i < this.dataForm.shipProgressDesc.length; i++) {
					let shipProgressDesc = this.dataForm.shipProgressDesc[i];
					if (shipProgressDesc.subjectNo === subjectNo) {
						let reportDescInfos = shipProgressDesc.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '020302' && this.dataForm.paintingProgressList != undefined && this.dataForm.paintingProgressList.length > 0) {
				for (var i = 0; i < this.dataForm.paintingProgressList.length; i++) {
					let paintingProgress = this.dataForm.paintingProgressList[i];
					if (paintingProgress.subjectNo === subjectNo) {
						let reportDescInfos = paintingProgress.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '020303' && this.dataForm.turbineProgressDesc != undefined && this.dataForm.turbineProgressDesc.length > 0) {
				for (var i = 0; i < this.dataForm.turbineProgressDesc.length; i++) {
					let turbineProgressDesc = this.dataForm.turbineProgressDesc[i];
					if (turbineProgressDesc.subjectNo === subjectNo) {
						let reportDescInfos = turbineProgressDesc.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '020304' && this.dataForm.electricalProgressDesc != undefined && this.dataForm.electricalProgressDesc.length > 0) {
				for (var i = 0; i < this.dataForm.electricalProgressDesc.length; i++) {
					let electricalProgressDesc = this.dataForm.electricalProgressDesc[i];
					if (electricalProgressDesc.subjectNo === subjectNo) {
						let reportDescInfos = electricalProgressDesc.reportDescInfos;
						for (var j = 0; j < reportDescInfos.length; j++) {
							if (reportDescInfos[j].sort > sort) {
								sort = reportDescInfos[j].sort
							}
						}
					}
				}
			} else if (dataType === '020300' && this.dataForm.customMajorProgressList != undefined && this.dataForm.customMajorProgressList.length > 0) {
				for (var i = 0; i < this.dataForm.customMajorProgressList.length; i++) {
					let customMajorProgress = this.dataForm.customMajorProgressList[i];
					if (customMajorProgress.majorCode === major) {
						let progressList = customMajorProgress.progressList;
						for (var j = 0; j < progressList.length; j++) {
							if (progressList[j].subjectNo === subjectNo) {
								let reportDescInfos = progressList[j].reportDescInfos;
								for (var k = 0; k < reportDescInfos.length; k++) {
									if (reportDescInfos[k].sort > sort) {
										sort = reportDescInfos[k].sort
									}
								}
							}
						}
					}
				}
			} else if (dataType === '030400' && this.dataForm.disAccordDesc != undefined && this.dataForm.disAccordDesc.length > 0) {
				for (var i = 0; i < this.dataForm.disAccordDesc.length; i++) {
					if (this.dataForm.disAccordDesc[i].sort > sort) {
						sort = this.dataForm.disAccordDesc[i].sort
					}
				}
			} else if (dataType === '030500' && this.dataForm.constructionQualityDesc != undefined && this.dataForm.constructionQualityDesc.length > 0) {
				for (var i = 0; i < this.dataForm.constructionQualityDesc.length; i++) {
					let constructionQualityDesc = this.dataForm.constructionQualityDesc[i];
					if (constructionQualityDesc.subjectNo === subjectNo) {
						let conProgressList = constructionQualityDesc.conProgressList;
						for (var j = 0; j < conProgressList.length; j++) {
							if (conProgressList[j].major === major) {
								let descProgressList = conProgressList[j].descProgressList;
								for (var k = 0; k < descProgressList.length; k++) {
									if (descProgressList[k].sort > sort) {
										sort = descProgressList[k].sort
									}
								}
							}
						}
					}
				}
			} else if (dataType === '030700' && this.dataForm.designEditDesc != undefined && this.dataForm.designEditDesc.length > 0) {
				for (var i = 0; i < this.dataForm.designEditDesc.length; i++) {
					if (this.dataForm.designEditDesc[i].sort > sort) {
						sort = this.dataForm.designEditDesc[i].sort
					}
				}
			} else if (dataType === '040000' && this.dataForm.meetingDesc != undefined && this.dataForm.meetingDesc.length > 0) {
				for (var i = 0; i < this.dataForm.meetingDesc.length; i++) {
					if (this.dataForm.meetingDesc[i].sort > sort) {
						sort = this.dataForm.meetingDesc[i].sort
					}
				}
			} else if (dataType === '050000' && this.dataForm.hseInfoDesc != undefined && this.dataForm.hseInfoDesc.length > 0) {
				for (var i = 0; i < this.dataForm.hseInfoDesc.length; i++) {
					if (this.dataForm.hseInfoDesc[i].sort > sort) {
						sort = this.dataForm.hseInfoDesc[i].sort
					}
				}
			} else if (dataType === '060000' && this.dataForm.otherDesc != undefined && this.dataForm.otherDesc.length > 0) {
				for (var i = 0; i < this.dataForm.otherDesc.length; i++) {
					if (this.dataForm.otherDesc[i].sort > sort) {
						sort = this.dataForm.otherDesc[i].sort
					}
				}
			}
			return sort;
		},
		selectMeetingHandle(dataType) {
			this.meetingSelectVisible = true
			// 获取会议情况来源ids
			let meetIds = ''
			let meetingDesc = this.dataForm.meetingDesc
			if (meetingDesc != undefined && meetingDesc.length > 0) {
				for (var i = 0; i < meetingDesc.length; i++) {
					if (meetingDesc[i].sourceType != null && meetingDesc[i].sourceType == '1' && meetingDesc[i].sourceId != null) {
						meetIds = meetIds + meetingDesc[i].sourceId
						if (i < meetingDesc.length - 1) {
							meetIds = meetIds + ','
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.meetingSelect.init(this.dataForm.beginTime, this.dataForm.endTime, meetIds, dataType)
			})
		},
		margeSelectMeetingItems(items) {
			this.meetingSelectVisible = false;
			let meetIds = items.map((item) => item.meetId);
			this.saveMeetingFiles(meetIds)
		},
		saveMeetingFiles(meetIds) {
			// 计算最大排序值
			let sort = 0;
			let meetingDesc = this.dataForm.meetingDesc
			if (meetingDesc != undefined && meetingDesc.length > 0) {
				for (var i = 0; i < meetingDesc.length; i++) {
					if (meetingDesc[i].sort > sort) {
						sort = meetingDesc[i].sort
					}
				}
			}
			let _url = "/business/monthlyreportdescinfo/saveMeetingFiles";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					monthlyRecNo: this.recNo,
					meetIds: meetIds,
					sort: sort + 1
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getMonthlySituationList();
				}
			});
		},
		selectCoordinateHandle(dataType) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			// 获取协调记录来源ids
			let coordinateNos = ''
			let meetingDesc = this.dataForm.meetingDesc
			if (meetingDesc != undefined && meetingDesc.length > 0) {
				for (var i = 0; i < meetingDesc.length; i++) {
					if (meetingDesc[i].sourceType != null && meetingDesc[i].sourceType == '2' && meetingDesc[i].sourceId != null) {
						coordinateNos = coordinateNos + meetingDesc[i].sourceId
						if (i < meetingDesc.length - 1) {
							coordinateNos = coordinateNos + ','
						}
					}
				}
			}
			this.selectCoordinateVisible = true
			this.$nextTick(() => {
				this.$refs.selectCoordinate.init(this.recNo, sort + 1, dataType, coordinateNos, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		lastRecordRefHandle(dataType, subjectNo, major, majorName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType, subjectNo, major);
			this.lastRecordRefVisible = true;
			this.$nextTick(() => {
				this.$refs.lastRecordRef.init(this.recNo, sort + 1, dataType, subjectNo, major, majorName)
			})
		},
		getMonthlySituationList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/getMonthlySituationList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.projectDesc = data.body.projectDesc
					this.dataForm.progressPlanDesc = data.body.progressPlanDesc
					this.dataForm.shipProgressDesc = data.body.shipProgressDesc
					this.dataForm.paintingProgressList = data.body.paintingProgressList
					this.dataForm.turbineProgressDesc = data.body.turbineProgressDesc
					this.dataForm.electricalProgressDesc = data.body.electricalProgressDesc
					this.dataForm.customMajorProgressList = data.body.customMajorProgressList
					this.dataForm.disAccordDesc = data.body.disAccordDesc
					this.dataForm.constructionQualityDesc = data.body.constructionQualityDesc
					this.dataForm.designEditDesc = data.body.designEditDesc
					this.dataForm.meetingDesc = data.body.meetingDesc
					this.dataForm.hseInfoDesc = data.body.hseInfoDesc
					this.dataForm.otherDesc = data.body.otherDesc
				}
			});
		},
		getMonthlyPhotoList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/getMonthlyPhotoList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.progressPhotoRecords = data.body.progressPhotoRecords
					this.dataForm.qualityPhotoRecords = data.body.qualityPhotoRecords
				}
			});
		},
		deleteMonthlyReportFile(recNo, dataType) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthlyreportdescinfo/delete/" + recNo,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getMonthlySituationList()
							}
						})
					}
				});
			})
		},
		updateImgContent(recNo, photoContent) {
			this.updateImgContentVisable = true;
			this.photoRecNo = recNo;
			this.updatePhotoContent = photoContent;
		},
		saveImgContent() {
			// 直接更新到db
			let _url = "/business/monthlyreportphoto/updatePhotoContent";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.photoRecNo,
					photoRemark: this.updatePhotoContent,
					monthlyRecNo: this.recNo
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: '操作成功',
						type: 'success',
						duration: 1500,
						onClose: () => {
							this.updateImgContentVisable = false
							this.getMonthlyPhotoList()
						}
					})
				}
			});
			// let idxs = this.contentIdx
			// let photoList = []
			// if (this.photoType === 'progress') {
			// 	photoList = this.dataForm.progressPhotoRecords[idxs].photoList
			// } else if (this.photoType === 'quality') {
			// 	photoList = this.dataForm.qualityPhotoRecords[idxs].photoList
			// }
			// for (var i = 0; i < photoList.length; i++) {
			// 	if (photoList[i].recNo === this.photoRecNo) {
			// 		photoList[i].photoContent = this.updatePhotoContent
			// 		break
			// 	}
			// }
			// this.updateImgContentVisable = false;
		},
		/* 照片拖拽 end */
		downloadHandle(url, filename) {
			filename = this.getSuffix(url, filename)
			this.getBlob(url, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			// 正则匹配：判断文件名是否包含 .后缀名（支持常见后缀，且不是最后一个字符）
			const hasSuffix = /\.[a-zA-Z0-9]+$/.test(filename);
			// 如果已经有后缀，直接返回原文件名；没有则拼接URL里的后缀
			if (hasSuffix) {
				return filename;
			}
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		objectSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterProjectNo(this.dataForm.shipProgressList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		flitterProjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.projectNo === arr[index - 1].projectNo) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		delPhotoImg(index) {
			this.photoList.splice(index, 1);
		},
		editHandle(id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, this.recNo)
			})
		},
		handleProgressPhotoSelect(progressPhotoRecord, index) {
			this.selectPhotoType = '2'
			this.qpPhotoSelectVisible = true
			let photoList = progressPhotoRecord.photoList;
			this.qpPhotoIndex = index
			// 获取现场照片来源ids
			let recNos = ''
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					recNos = recNos + photoList[i].sourceId;
					if (i < photoList.length - 1) {
						recNos = recNos + ','
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.qpPhotoSelect.init("2", this.dataForm.beginTime, this.dataForm.endTime, recNos, progressPhotoRecord.subjectNo)
			})
		},
		handleQualityPhotoSelect(qualityPhotoRecord, index) {
			this.selectPhotoType = '1'
			this.qpPhotoSelectVisible = true
			let photoList = qualityPhotoRecord.photoList;
			this.qpPhotoIndex = index
			// 获取现场照片来源ids
			let recNos = ''
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					recNos = recNos + photoList[i].sourceId;
					if (i < photoList.length - 1) {
						recNos = recNos + ','
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.qpPhotoSelect.init("1", this.dataForm.beginTime, this.dataForm.endTime, recNos, qualityPhotoRecord.subjectNo)
			})
		},
		margeSelectItems(items) {
			let records = []
			let maxSort = 0;
			let photoList = []
			if (this.selectPhotoType === '2') {
				photoList = this.dataForm.progressPhotoRecords[this.qpPhotoIndex].photoList
			} else if (this.selectPhotoType === '1') {
				photoList = this.dataForm.qualityPhotoRecords[this.qpPhotoIndex].photoList

			}
			if (photoList != undefined && photoList.length > 0) {
				for (var i = 0; i < photoList.length; i++) {
					if (photoList[i].sort > maxSort) {
						maxSort = photoList[i].sort
					}
				}
			}
			if (items != undefined && items.length > 0) {
				for (var i = 0; i < items.length; i++) {
					let progressPhotot = {
						detailRecNo: this.dataForm.monthlyDetailRecNo,
						photoKind: this.selectPhotoType,
						subjectNo: items[i].subjectNo,
						compressedPath: items[i].compressedPath,
						sort: maxSort + 1 + i,
						photoPath: items[i].photoFilePath,
						thumbnailPath: items[i].thumbnailPath,
						sourceId: items[i].recNo,
						photoRemark: items[i].photoContent,
						major: items[i].majorCode,
						photoPathUri: items[i].photoPathUri
					}
					records.push(progressPhotot)
				}
			}
			this.saveBatchMonthlyQPPhoto(records);

			// let noSubject = true;
			// // 循环处理选择的图片
			// for (var selectItem of items) {
			// 	for (var record of records) {
			// 		// 相同的标的物
			// 		if (record.subjectNo == selectItem.subjectNo) {
			// 			let exist = false;
			// 			for (var photo of record.photoList) {
			// 				if (photo.photoPathUri == selectItem.photoPathUri) {
			// 					exist = true
			// 					break
			// 				}
			// 			}
			// 			if (!exist) {
			// 				record.photoList.push(selectItem)
			// 				break
			// 			}
			// 		}
			// 	}
			// }
		},
		refreshEnclosureFiles() {
			let _url = "/business/monthlyreportinfo/refreshEnclosureFiles/" + this.recNo;
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: []
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getEnclosureList();
				}
			});
		},
		saveBatchMonthlyQPPhoto(records) {
			let _url = "/business/monthlyreportphoto/saveBatch";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					records: records,
					monthlyRecNo: this.recNo
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.qpPhotoSelectVisible = false;
							this.getMonthlyPhotoList();
						}
					});
				}
			});
		},
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/monthreportenclosure/delete",
					method: "POST",
					data: this.$http.adornData([id], false),
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getEnclosureList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				});
			})
		},
		getEnclosureList() {
			this.$http({
				url: this.$store.state.httpUrl + `/business/monthreportenclosure/listByMonthlyId`,
				method: 'get',
				params: {
					workNo: $common.getItem("workNo"),
					detailRecNo: this.recNo
				}
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// this.enclosureList = data.body
					let enclosureFiles = []
					if (data.body != undefined && data.body.length > 0) {
						for (var i = 0; i < data.body.length; i++) {
							data.body[i].fileName = '附件' + (i + 1) + "：" + data.body[i].fileName
							enclosureFiles.push(data.body[i]);
						}
					}
					this.enclosureList = enclosureFiles;
				}
			})
		},
		delMeetDialogPhoto(index) {
			this.meetPhotoList.splice(index, 1);
		},
		addPhoto(flag) {
			this.photoList = [];
			this.photoContent = '';
			this.dialogVisible = true;
			this.photoFlag = flag;
		},
		addMeetingDescPhoto(idx) {
			this.meetPhotoListIndex = idx
			this.meetPhotoList = [];
			this.meetPhotoContent = '';
			this.meetPhotoDialogVisible = true;
		},
		delMeetDesc(index) {
			this.dataForm.meetingDesc.splice(index, 1);
		},
		uploadTempImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadTempImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode == 200) {
					this.photoList.push({
						photoPath: res.body.fileSavePath,
						photoPathUri: res.body.fileUri
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		uploadMeetImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadMeetImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.meetPhotoList.push({
						photoFilePath: res.body.fileSavePath,
						photoFilePathUrl: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		getMajorList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getMajorByWorkNo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.majorList = data.body;
				}
			});
		},
		getProjectCode(projectNo) {
			for (var item in this.subjectList) {
				if (this.subjectList[item].displayValue == projectNo) {
					return this.subjectList[item].projectNo
				}
			}
		},
		savePhotoList() {
			if (!this.photoPojectNo) {
				this.$message.error("请选择工程编号");
				return;
			}
			if (!this.photoContent) {
				this.$message.error('请填写照片描述');
				return;
			}
			if (!this.photoList || this.photoList.length === 0) {
				this.$message.error('请选择上传照片');
				return;
			}

			if (this.photoFlag === 1) {
				let flag = false;
				if (this.dataForm.progressPhotoRecords && this.dataForm.progressPhotoRecords.length > 0) {
					for (var i = 0; i < this.dataForm.progressPhotoRecords.length; i++) {
						if (this.dataForm.progressPhotoRecords[i].subjectNo == this.photoPojectNo) {
							flag = true;
							let item = {
								photoContent: this.photoContent,
								photoFilePath: this.photoList[0].photoPath,
								photoPathUri: this.photoList[0].photoPathUri,
								subjectNo: this.photoPojectNo
							};
							this.dataForm.progressPhotoRecords[i].photoList.push(item);
							break;
						}
					}
				}

				if (!flag) {
					let photoList = [];
					let progressPhotoRecord = {
						photoContent: this.photoContent,
						photoFilePath: this.photoList[0].photoPath,
						photoPathUri: this.photoList[0].photoPathUri,
						subjectNo: this.photoPojectNo
					}
					photoList.push(progressPhotoRecord);
					let item = {
						projectNo: this.getProjectCode(this.photoPojectNo),
						subjectNo: this.photoPojectNo,
						photoList: photoList
					};
					this.dataForm.progressPhotoRecords.push(item);
				}
			} else {
				let flag = false;
				if (this.dataForm.qualityPhotoRecords && this.dataForm.qualityPhotoRecords.length > 0) {
					for (var i = 0; i < this.dataForm.qualityPhotoRecords.length; i++) {
						if (this.dataForm.qualityPhotoRecords[i].subjectNo == this.photoPojectNo) {
							flag = true;
							let item = {
								photoContent: this.photoContent,
								photoFilePath: this.photoList[0].photoPath,
								photoFilePathUrl: this.photoList[0].photoPathUri,
								subjectNo: this.photoPojectNo
							};
							this.dataForm.qualityPhotoRecords[i].photoList.push(item);
							break;
						}
					}
				}

				if (!flag) {
					let photoList = [];
					let qualityPhotoRecord = {
						photoContent: this.photoContent,
						photoFilePath: this.photoList[0].photoPath,
						photoFilePathUrl: this.photoList[0].photoPathUri,
						subjectNo: this.photoPojectNo
					}
					photoList.push(qualityPhotoRecord);
					let item = {
						projectNo: this.getProjectCode(this.photoPojectNo),
						subjectNo: this.photoPojectNo,
						photoList: photoList
					};
					this.dataForm.qualityPhotoRecords.push(item);
				}
			}
			this.dialogVisible = false;
		},
		saveMeetPhotoList() {
			if (!this.meetPhotoContent) {
				this.$message.error('请填写照片描述');
				return;
			}
			if (!this.meetPhotoList || this.meetPhotoList.length === 0) {
				this.$message.error('请选择上传照片');
				return;
			}
			let idx = this.meetPhotoListIndex

			if (this.dataForm.meetingDesc[idx].photoRecords == null) {
				this.dataForm.meetingDesc[idx].photoRecords = []
			}
			let item = {
				photoContent: this.meetPhotoContent,
				photoFilePath: this.meetPhotoList[0].photoFilePath,
				photoFilePathUrl: this.meetPhotoList[0].photoFilePathUrl,
			};
			this.dataForm.meetingDesc[idx].photoRecords.push(item);

			this.meetPhotoDialogVisible = false;
		},
		addConstructionQualityDescItem(subjectNo, major, index, index1) {
			let item = {
				monthlyRecNo: this.recNo,
				recNo: '',
				subjectNo: subjectNo,
				major: major,
				descContent: '',
				dataType: '030500',
				updUserName: $common.getItem("userName"),
				updDate: this.getCurrentDate(),
				workNo: $common.getItem("workNo")
			};
			this.dataForm.constructionQualityDesc[index].conQualityList[index1].qualityDescList.push(item);
			this.addFlg = true;
		},
		addDesignEditDescItem() {
			let item = {
				monthlyRecNo: this.recNo,
				recNo: '',
				descContent: '',
				dataType: '030700',
				updUserName: $common.getItem("userName"),
				updDate: this.getCurrentDate(),
				workNo: $common.getItem("workNo")
			};
			this.dataForm.designEditDesc.push(item);
			this.addFlg = true;
		},
		addShipProgressDescItem(subjectNo, index) {
			let item = {
				monthlyRecNo: this.recNo,
				recNo: '',
				subjectNo: subjectNo,
				descContent: '',
				dataType: '020301',
				updUserName: $common.getItem("userName"),
				updDate: this.getCurrentDate(),
				workNo: $common.getItem("workNo")
			};
			this.dataForm.shipProgressDesc[index].reportDescInfos.push(item);
			this.addFlg = true;
		},
		addHseInfoDescItem() {
			let item = {
				monthlyRecNo: this.recNo,
				recNo: '',
				descContent: '',
				dataType: '050000',
				updUserName: $common.getItem("userName"),
				updDate: this.getCurrentDate(),
				workNo: $common.getItem("workNo")
			};
			this.dataForm.hseInfoDesc.push(item);
			this.addFlg = true;
		},
		deleteHseInfoDescItem(index) {
			this.dataForm.hseInfoDesc.splice(index, 1);
		},
		addMeetingDescItem() {
			let item = {
				dataType: '040000',
				descContent: '',
				photoRecords: []
			};
			this.dataForm.meetingDesc.push(item)
		},
		deleteMeetingDescItem(index) {
			this.dataForm.meetingDesc.splice(index, 1);
		},
		addOtherDescItem() {
			let item = {
				monthlyRecNo: this.recNo,
				recNo: '',
				descContent: '',
				dataType: '060000',
				updUserName: $common.getItem("userName"),
				updDate: this.getCurrentDate(),
				workNo: $common.getItem("workNo")
			};
			this.dataForm.otherDesc.push(item);
			this.addFlg = true;
		},
		deleteOtherDescItem(index) {
			this.dataForm.otherDesc.splice(index, 1);
		},
		goBack() {
			this.$router.back()
		},
		getNodeInfoList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectprogressnoderecord/list/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.nodeList = data.body.records;
					this.headers = data.body.headers;
				}
			})
		},
		getMonthlyInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/monthlyreportinfo/getMonthlyById",
				method: "get",
				params: {
					workNo: this.workNo,
					recNo: this.recNo
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body;
					this.basicVisible = false;
					this.addFlg = false;
					this.updateFlg = false;
					this.updateDescRecNo = '';
				}
			});
		},
		delMeetPhoto(index1, index2) {
			this.dataForm.meetingDesc[index1].photoRecords.splice(index2, 1);
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getMonthSubjectList/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					this.showSubjectName = false;
					if (this.subjectList != null && this.subjectList != undefined && this.subjectList.length > 1) {
						this.showSubjectName = true;
					}
				}
			});
		},
		// dataFormSubmit() {
		// 	let _url = "/business/monthlyreportinfo/saveMonthlyReport";
		// 	this.dataForm.recNo = this.recNo;
		// 	this.dataForm.meetingDesc = this.dataForm.meetingDesc
		// 	this.$http({
		// 		url: this.$store.state.httpUrl + _url,
		// 		method: "post",
		// 		data: this.$http.adornData(this.dataForm)
		// 	}).then(({ data }) => {
		// 		if (data && data.resultCode === 200) {
		// 			this.$message({
		// 				message: "操作成功",
		// 				type: "success",
		// 				duration: 1500,
		// 				onClose: () => {
		// 					this.$router.push({ name: 'monthly' });
		// 				}
		// 			});
		// 		} else {
		// 			this.$message.error(data.msg);
		// 		}
		// 	});
		// },
		jump_to_basic() {
			this.menuId = 'basic'
			this.$refs["basic"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_overview() {
			this.menuId = 'overview'
			this.$refs["overview"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_progress() {
			this.menuId = 'progress'
			this.$refs["progress"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_quality() {
			this.menuId = 'quality'
			this.$refs["quality"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_hse() {
			this.menuId = 'hse'
			this.$refs["hse"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_meet() {
			this.menuId = 'meet'
			this.$refs["meet"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_other() {
			this.menuId = 'other'
			this.$refs["other"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_enclosure() {
			this.menuId = 'enclosure'
			this.$refs["enclosure"].scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableScnenRowClassName({ row, rowIndex });
		},
		flitterSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectName === arr[index - 1].subjectName) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		flitterData(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.title === arr[index - 1].title) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		objectNodeSpanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterSubjectNo(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			} else if (columnIndex === 1) {
				// this.tableData  修改
				const _row = (this.flitterData(this.nodeList).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
.el-form-item {
	margin-bottom: 5px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}

.elCardTitle {
	font-size: 18px;
	font-weight: bold;
	color: #00428e;
	margin-bottom: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #00428e;
}

.time {
	font-size: 13px;
	color: #999;
}

.bottom {
	margin-top: 3px;
	line-height: 12px;
	vertical-align: bottom;
}

.button {
	padding: 0;
	float: right;
}

.image {
	width: 100%;
	height: 200px;
	margin-top: 5px;
	display: block;
}

.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}

.itemLabelspan {
	font-weight: bold;
	// color: #606266;
	margin-right: 10px;
	font-size: 13px !important;
}

.itemLabeltext {
	color: black;
	margin-right: 10px;
	font-size: 13px !important;

}

.t-column-ellipsis {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	padding-bottom: 10px;
	height: 50px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
	font-size: 13px !important;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.border-form .el-row.set_border {
	// border-bottom: solid #dadada 1px;
	// border-left: solid #dadada 1px;
	// border-right: solid #dadada 1px;
	border: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 2px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

.btn1 {
	bottom: 13px;
	margin-left: -60px;
	position: fixed;
}

.rebtn1 {
	bottom: 13px;
	position: fixed;
}

.set_bg {
	width: 65%;
	height: 50px;
	bottom: 6px;
	position: fixed;
	left: 20%;
	background-color: #f7f1f1;
}

.set_menu {
	position: fixed;
	cursor: pointer;
	left: 92%;
	font-size: smaller;
	color: #6d6c6c;
}

.set_btn {
	left: 91%;
	position: fixed;
	width: 9px;
	height: 9px;
	background-color: transparent;
	background: white;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid #81D3F8;
}

.set_btn_border {
	left: 91%;
	position: fixed;
	width: 9px;
	height: 9px;
	background-color: transparent;
	background: #81D3F8;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid #81D3F8;
}


.itemLabelspanDetail {
	font-weight: bold;
	// color: #606266;
	margin-right: 191px;
	font-size: 12px !important;
}

.itemLabelspanDetail1 {
	font-weight: bold;
	// color: #606266;
	margin-right: 157px;
	font-size: 13px !important;
}

.desc_zw {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: white;
}

.desc_zw_bc {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #e1f1ff;
}

.set_span {
	display: block;
	/* 将span转换为块级元素 */
	max-width: 275px;
	/* 设置固定长度 */
	white-space: nowrap;
	/* 不换行 */
	overflow: hidden;
	/* 超出部分隐藏 */
	text-overflow: ellipsis;
	/* 超出部分显示省略号 */
	cursor: default;
	/* 将鼠标光标设置为默认样式 */
	font-size: 13px !important;
}

.subject_blank {
	margin-left: 50px
}

.set_nonS {
	border-bottom: solid #dadada 1px;
	min-height: 28px !important;
	padding-top: 8px;
	padding-left: 5px;
}

.desc_span {
	padding-top: 2px;
	line-height: 22px;
	border-bottom: solid transparent 1px;
	white-space: pre-line;
	font-size: 13px;
}

.desc_btn {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #169BD5;
	margin-top: -8px;
}

.un_col {
	border: 1px solid transparent;
	text-align: center;
	margin-top: -5px;
}

.desc_zw {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: white;
}

::v-deep .monthly-input .el-input__inner {
	height: 26px !important;
	line-height: 26px !important;
	padding: 0 8px !important;
	/* 留一点内边距，文字不贴边 */
	border: 1px solid #DCDFE6 !important;
	/* 强制显示边框 */
	border-radius: 4px !important;
	box-sizing: border-box !important;
}


::v-deep(.el-form-item__content) {
	flex: 1 !important;
	width: 100% !important;
}

::v-deep(.sp-input) {
	width: 100% !important;
	display: block !important;
}

::v-deep(.el-form-item__content) {
	flex: 1 !important;
	width: 100% !important;
}

::v-deep(.sp-input) {
	width: 100% !important;
	display: block !important;
	font-size: 13px !important;
}

::v-deep(.sp-input .el-input__inner) {
	width: 100% !important;
	box-sizing: border-box !important;
}
</style>
